import AdminTLDVSettings from './AdminTLDVSettings';

export default AdminTLDVSettings;
